export default "__VITE_ASSET__lV9W1hjR__"